import { ref, watch, type Ref } from 'vue'
import { useToggleBookmarkMutation } from '../../browse/api/useToggleBookmarkMutation'
import type { PropertyDetailData } from '../utils/propertyDetailUtils'

// Bookmark state + optimistic toggle. Syncs the local ref off the query's
// raw data on mount/refetch, then mutates with optimistic flip + rollback.
// Decoupled from the view-model composable because not every consumer
// needs bookmark (InvestDrawerContainer doesn't).
export const usePropertyBookmark = (propertyId: string, raw: Ref<PropertyDetailData | null>) => {
  const isBookmarked = ref(false)
  watch(
    raw,
    (data) => {
      if (data) isBookmarked.value = data.isBookmarked ?? false
    },
    { immediate: true },
  )

  const bookmarkMutation = useToggleBookmarkMutation()

  const toggleBookmark = () => {
    if (bookmarkMutation.isPending.value) return
    const prev = isBookmarked.value
    isBookmarked.value = !prev
    bookmarkMutation.mutate(
      { propertyId, isCurrentlyBookmarked: prev },
      { onError: () => (isBookmarked.value = prev) },
    )
  }

  return { isBookmarked, toggleBookmark }
}
